"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

require("core-js/modules/es.object.keys.js");

require("core-js/modules/es.array.index-of.js");

require("core-js/modules/es.symbol.js");

require("core-js/modules/es.symbol.description.js");

require("core-js/modules/es.object.to-string.js");

require("core-js/modules/es.symbol.iterator.js");

require("core-js/modules/es.array.iterator.js");

require("core-js/modules/es.string.iterator.js");

require("core-js/modules/web.dom-collections.iterator.js");

require("core-js/modules/es.array.slice.js");

require("core-js/modules/es.function.name.js");

require("core-js/modules/es.array.from.js");

require("core-js/modules/es.regexp.exec.js");

require("core-js/modules/es.weak-map.js");

require("core-js/modules/es.object.define-property.js");

require("core-js/modules/es.object.get-own-property-descriptor.js");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Header = _interopRequireDefault(require("./Header/Header"));

var _Expander = _interopRequireDefault(require("./Expander/Expander"));

require("./Panel.css");

var _jsxRuntime = require("react/jsx-runtime");

var _excluded = ["expanded", "collapsible", "expandDir", "preTools", "postTools", "style", "title", "onTitleMouseOver", "onTitleMouseOut", "titleStyle", "onClose"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

/**
 * The Panel Component.
 */
var Panel = function Panel(_ref) {
  var _ref$expanded = _ref.expanded,
      expanded = _ref$expanded === void 0 ? true : _ref$expanded,
      _ref$collapsible = _ref.collapsible,
      collapsible = _ref$collapsible === void 0 ? true : _ref$collapsible,
      expandDir = _ref.expandDir,
      preTools = _ref.preTools,
      postTools = _ref.postTools,
      _ref$style = _ref.style,
      style = _ref$style === void 0 ? null : _ref$style,
      title = _ref.title,
      onTitleMouseOver = _ref.onTitleMouseOver,
      onTitleMouseOut = _ref.onTitleMouseOut,
      titleStyle = _ref.titleStyle,
      _ref$onClose = _ref.onClose,
      onClose = _ref$onClose === void 0 ? null : _ref$onClose,
      otherProps = _objectWithoutProperties(_ref, _excluded);

  var _useState = (0, _react.useState)(expanded),
      _useState2 = _slicedToArray(_useState, 2),
      internalExpanded = _useState2[0],
      setInternalExpanded = _useState2[1];

  var toggleCollapse = (0, _react.useCallback)(function () {
    setInternalExpanded(function (prevInternalExpanded) {
      return !prevInternalExpanded;
    });
  }, []);
  var showHeader = title.length || collapsible;
  var className = "rolext-panel".concat(internalExpanded ? ' rolext-panel-expanded' : '');
  return /*#__PURE__*/(0, _jsxRuntime.jsxs)("div", {
    className: className,
    style: style,
    children: [showHeader && /*#__PURE__*/(0, _jsxRuntime.jsx)(_Header.default, {
      title: title,
      collapsible: collapsible,
      toggleCollapse: toggleCollapse,
      preTools: preTools,
      postTools: postTools,
      onClose: onClose,
      onMouseOver: onTitleMouseOver,
      onMouseOut: onTitleMouseOut,
      style: titleStyle
    }), /*#__PURE__*/(0, _jsxRuntime.jsx)(_Expander.default, {
      expanded: internalExpanded,
      expandDir: expandDir,
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)("div", {
        className: "rolext-panel-body-el",
        children: otherProps.children
      })
    })]
  });
};

Panel.propTypes = {
  /**
   * Set to true by default. 
   * Passing expanded as false will show the 
   * component collapsed.
   */
  expanded: _propTypes.default.bool,

  /**
   * If collapsible is true, the panel header will display 
   * a collapse/expand control to collapse/expand the panel.
   */
  collapsible: _propTypes.default.bool,

  /**
   * Not used currently.
   * To be used in the future to allow to expand in a horizontal
   * direction.
   * @ignore
   */
  expandDir: _propTypes.default.string,

  /**
   * Arbitrary tools, any element or React component you’d like, 
   * to be shown before the collapse/expand control.
   */
  preTools: _propTypes.default.node,

  /**
   * Arbitrary tools, any element or React component you’d like, 
   * to be shown in end, after the close control.
   */
  postTools: _propTypes.default.node,

  /**
   * A CSS Style to render the Panel
   */
  style: _propTypes.default.object,

  /**
   * a title to be shown
   */
  title: _propTypes.default.node.isRequired,

  /**
   * A callback function to be called once the
   * mouse is over the Header component.
   */
  onTitleMouseOver: _propTypes.default.func,

  /**
  * A callback function to be called once the
  * mouse is moved out of the Header component.
  */
  onTitleMouseOut: _propTypes.default.func,

  /**
   * A CSS Style to render the Title
   */
  titleStyle: _propTypes.default.object,

  /**
   * A callback function to be called once the
   * user clicks in the close control.
   * If null, the close control will not be 
   * shown.
   */
  onClose: _propTypes.default.func
};
var _default = Panel;
exports.default = _default;